import {
  SourceEntityMigrationType,
  type ISourceEntity,
} from '@principle-theorem/practice-migrations/interfaces';
import { SourceEntity } from '../../../source/source-entity';
import { ADAItemSourceEntity } from '../../../exact/source/entities/ada-item';
import { ExactTreatmentType } from '../../../exact/source/entities/patient-treatments';
import { PATIENT_USED_ITEM_CODE_TREATMENT_RESOURCE_TYPE } from '../../../exact/source/entities/used-item-code-treatments';

const PRACTICE_WORKS_USED_ITEM_CODE_TREATMENT_SOURCE_ENTITY: ISourceEntity =
  SourceEntity.init({
    metadata: {
      label: 'Item Codes Used as Treatments List',
      description: '',
      idPrefix: PATIENT_USED_ITEM_CODE_TREATMENT_RESOURCE_TYPE,
      migrationType: SourceEntityMigrationType.Automatic,
    },
  });

// Enriches descriptions from _tx_code_defs_ since convtreatment.servicedescription
// is always empty in PracticeWorks databases
const TREATMENT_SOURCE_QUERY = `
SELECT
  sub.item_code,
  COALESCE(
    (SELECT tcd.description FROM _tx_code_defs_ tcd
     WHERE tcd.medical_code = CASE
       WHEN sub.item_code ~ '^[0-9]+$' THEN CAST(sub.item_code AS bigint)
       ELSE NULL END
     AND tcd.description IS NOT NULL AND tcd.description != ''
     ORDER BY tcd.tx_code_id
     LIMIT 1),
    ''
  ) AS description,
  ROW_NUMBER() OVER (ORDER BY sub.item_code) AS id
FROM (
  SELECT DISTINCT servicecode AS item_code
  FROM convtreatment
  WHERE LOWER(treatmenttype) != '${ExactTreatmentType.Base}'
  AND servicecode != ''
) sub
ORDER BY sub.item_code
`;

export class PracticeWorksUsedItemCodeTreatmentSourceEntity extends ADAItemSourceEntity {
  override sourceEntity = PRACTICE_WORKS_USED_ITEM_CODE_TREATMENT_SOURCE_ENTITY;
  override entityResourceType = PATIENT_USED_ITEM_CODE_TREATMENT_RESOURCE_TYPE;
  override sourceQuery = TREATMENT_SOURCE_QUERY;
}
